import { createRef, useEffect, useRef } from "react";
import { IProblem } from "src/lib/ProblemGenerators/sharedTypes";

type Props = {
    problems: IProblem[]
    doScroll: boolean;
}
export default function History(props: Props) {
    const thing = createRef<HTMLDivElement>();
    useEffect(() => {
        
        if (thing.current !== null && props.doScroll) {
            thing.current.scrollIntoView({behavior: "smooth"});
        }
    }, [ props.problems, props.doScroll ])
    
    return (
        <div className="w-full overflow-hidden h-full">
            
            <div className="h-full overflow-y-scroll">
                <div className="h-fit">
                    <ol className="list-decimal list-inside">
                    {
                        props.problems.map((problem, idx) => {
                            const color = problem.userAnswer === problem.correctAnswer ? "text-green-500" : "text-red-500";

                            return (
                                <li key={idx}><span className={color}>{problem.display} = {problem.userAnswer}</span> {problem.correctAnswer !== problem.userAnswer ? `(${problem.correctAnswer})` : ""}</li>
                            )
                        })
                    }
                    </ol>
                    <div ref={thing} className="h-4">&nbsp;</div>
                </div>
            </div>
        </div>

    )
}